export const sidemenu = {
  account: "Kundkonto",
  homes: "Boenden",
  users: "Brukare",
  users2: "Brukare",
  staff: "Personal",
  employees: "Personal",
  overview: "Överblick",
  statistics: "Statistik",
  calendar: "Kalender",
  calendar2: "Kalender",
  awards: "Awards",

  organisation_info: "Organisationsinfotabell",
  organisation: " Organisation",
  sub_organisations: " Underorganisation",
  hr_organisation: " Organisation",
  hr_sub_organisations: " Underorganisation",
  hr_employees: "Personal",
  health_organisation: " Kundkonto",
  health_sub_organisations: " Boenden",
  health_employees: "Personal",
  company_label: "Företag",
  company_health: "Health",
  company_hr: "HR",
  company_info:
    "Vänligen välj företag här: Health eller HR (du kan alltid växla)!",

  access_level_super_admin: "Super Admin",
  access_level_account_admin: "Kontoadministratör",
  access_level_operations_manager: "Driftchef",
  access_level_home_manager: "Boendechef",
  logged_in_with: "Inloggad med ",
};
